import { render, staticRenderFns } from "./LoginTip.vue?vue&type=template&id=069d576e&scoped=true&"
import script from "./LoginTip.vue?vue&type=script&lang=js&"
export * from "./LoginTip.vue?vue&type=script&lang=js&"
import style0 from "./LoginTip.vue?vue&type=style&index=0&id=069d576e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d576e",
  null
  
)

export default component.exports